var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-tip"},[_c('a',{staticClass:"icon",attrs:{"href":"javascript:;"}}),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }